export const AGENT_BAGDES = {
    PREMIUM:"PREMIUM_BADGE"
}